<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="sherlock-bones-and-the-creepy-castle">
<p style="text-align: center;margin-top:150px;"><img alt="" src="media/file0.jpg" style="width:3.51664in;height:4.98568in"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?cf64c6e6